import { printHtml } from '@/shared/utils/print'
import { formatDateBR } from '@/shared/utils/date-validator'
import { showDialog } from '@/shared/sweetAlerts/showDialog'

const mixin = {
  methods: {
    async getProtocoloQrCode(examId) {
      if (!examId) {
        throw new Error('ExameID não informado!')
      }

      const res = await this.getClient().get(`/core/v2/Exam/GenerateProtocol?examId=${examId}`)
      return res.data?.data || res.data
    },
    montaImagemBase64(valor) {
      if (!valor) return ''
      return valor.startsWith('data:') ? valor : `data:image/png;base64,${valor}`
    },
    escapaTextoProtocolo(valor) {
      if (valor === null || valor === undefined) return ''
      return String(valor)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
    },
    montaHtmlProtocolo(protocolo) {
      const esc = this.escapaTextoProtocolo
      const qrCode = this.montaImagemBase64(protocolo.QRCodeB64 || protocolo.qrCodeB64)
      const logo = this.montaImagemBase64(protocolo.logoB64)
      const atendimento = esc(protocolo.examId)
      const dataNascimento = esc(formatDateBR(protocolo.birthDate) || protocolo.birthDate || '')
      const dataAtendimento = esc(formatDateBR(protocolo.examDate) || protocolo.examDate || '')

      return `<!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8" />
            <title>${this.$t('protocolo.exam_protocol')} - ${atendimento}</title>
            <style>
              @page { margin: 0; }
              * { box-sizing: border-box; }
              body {
                font-family: Arial, Helvetica, sans-serif;
                color: #222;
                margin: 0;
              }
              .protocolo {
                max-width: 760px;
                margin: 24px auto;
              }
              .moldura {
                border: 1px solid #e2e2e2;
                border-radius: 6px;
                padding: 24px;
              }
              .cabecalho {
                display: grid;
                grid-template-columns: 1fr 2fr;
                align-items: center;
                padding-bottom: 16px;
                border-bottom: 1px solid #e2e2e2;
                margin-bottom: 24px;
              }
              .cabecalho .logo { height: 48px; width: auto; max-width: 200px; object-fit: contain; justify-self: start; }
              .cabecalho h1 {
                margin: 0;
                font-size: 22px;
                text-decoration: underline;
                text-align: center;
              }
              .corpo {
                display: flex;
                justify-content: space-between;
                gap: 24px;
              }
              .dados {
                flex: 1;
                display: grid;
                grid-template-columns: 1.2fr 1fr;
                gap: 16px;
              }
              .dados > div { display: flex; flex-direction: column; }
              .dados .rotulo { font-size: 13px; font-weight: bold; }
              .dados .valor { font-size: 14px; }
              .instrucoes { grid-column: 2; grid-row: 3; line-height: 1.4; }
              .instrucoes .valor { margin-top: 6px; }
              .senha {
                align-self: flex-start;
                margin-top: 6px;
                background: #e0f2fe;
                color: #008ac4;
                border-radius: 4px;
                padding: 4px 6px;
                font-size: 12px;
                font-weight: bold;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
              .qr-area { text-align: center; }
              .qr-area .qrcode { width: 150px; height: 150px; object-fit: contain; }
              .qr-area .link { font-size: 10px; word-break: break-word; max-width: 150px; }
            </style>
          </head>
          <body>
            <div class="protocolo">
              <div class="moldura">
                <div class="cabecalho">
                  ${logo ? `<img class="logo" src="${logo}" alt="" />` : ''}
                  <h1>${this.$t('protocolo.exam_protocol')}</h1>
                </div>
                <div class="corpo">
                  <div class="dados">
                    <div>
                      <div class="rotulo">${this.$t('protocolo.social_name')}</div>
                      <div class="valor">${esc(protocolo.name)}</div>
                    </div>
                    <div>
                      <div class="rotulo">${this.$t('protocolo.attendance_date')}</div>
                      <div class="valor">${dataAtendimento}</div>
                    </div>
                    <div>
                      <div class="rotulo">${this.$t('protocolo.birth_date')}</div>
                      <div class="valor">${dataNascimento}</div>
                    </div>
                    <div>
                      <div class="rotulo">${this.$t('protocolo.exam_type')}</div>
                      <div class="valor">${esc(protocolo.specialty)}</div>
                    </div>
                    <div>
                      <div class="rotulo">${this.$t('protocolo.attendance')}</div>
                      <div class="valor">${atendimento}</div>
                      <div class="senha">${esc(this.$t('protocolo.web_password'))}: ${esc(protocolo.password)}</div>
                    </div>
                    <div class="instrucoes">
                      <div class="rotulo">${esc(this.$t('protocolo.access_title'))}</div>
                      <div class="valor">${esc(this.$t('protocolo.access_instructions'))}</div>
                    </div>
                  </div>
                  <div class="qr-area">
                    ${qrCode ? `<img class="qrcode" src="${qrCode}" alt="QR Code" />` : ''}
                    ${protocolo.link ? `<div class="link">${esc(protocolo.link)}</div>` : ''}
                  </div>
                </div>
              </div>
            </div>
          </body>
        </html>`
    },
    async imprimirProtocolo(examId) {
      if (!examId) return
      this.$root.$emit('showLoading')
      try {
        const protocolo = await this.getProtocoloQrCode(examId)
        await printHtml(this.montaHtmlProtocolo(protocolo))
      } catch (error) {
        showDialog({
          icon: 'error',
          title: this.$t('protocolo.error'),
          text: this.$t('protocolo.error_printing'),
          confirmButtonText: 'Ok',
        })
      } finally {
        this.$root.$emit('hideLoading')
      }
    }
  }
}

export default mixin
